import TopTimeConsumingMeetings from "./TopTimeConsumingMeetings";

export default TopTimeConsumingMeetings;
